<po-combo
  [p-label]="label"
  [p-placeholder]="placeholder"
  [p-help]="help"
  [p-required]="required"
  [p-disabled]="disabled"
  [name]="name"
  p-field-value="value"
  p-field-label="label"
  [p-filter-service]="$any(filterService)"
  p-clean="true"
  p-icon="po-icon po-icon-company"
  [ngModel]="value"
  (ngModelChange)="onChange($event)"
  (blur)="onTouchedFn()"
></po-combo>
